const CHAR_CODES = {
  ESCAPE: 27,
  ARROW_LEFT: 37,
  ARROW_UP: 38,
  ARROW_RIGHT: 39,
  ARROW_DOWN: 40,
  A: 'A'.charCodeAt(0),
  C: 'C'.charCodeAt(0),
  D: 'D'.charCodeAt(0),
  E: 'E'.charCodeAt(0),
  F: 'F'.charCodeAt(0),
  G: 'G'.charCodeAt(0),
  Q: 'Q'.charCodeAt(0),
  R: 'R'.charCodeAt(0),
  S: 'S'.charCodeAt(0),
  U: 'U'.charCodeAt(0),
  V: 'V'.charCodeAt(0),
  W: 'W'.charCodeAt(0),
  Z: 'Z'.charCodeAt(0),
};

export default CHAR_CODES;
